import ActivityFeedItemViewModel from '@/Components/ActivityFeed/Items/ActivityFeedItemViewModel';
import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import LocatorHelper from '@/Utility/LocatorHelper';
import layout from './ActivityFeedItem.html?raw';
export default class ActivityFeedItemControl extends Control {
    private jQueryControl: JQuery;

    constructor(private viewModel: ActivityFeedItemViewModel, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.applyTemplate(layout, this.jQueryControl, () => {
            this.widget(null);
        });

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'activity-feed-item',
            locator: LocatorHelper.buildLocator('activity-feed-item', this.viewModel.itemUnit, this.viewModel.itemIndex),
            controlIdent: this.identifier
        });
    }
}

ComponentManager.setControl('ActivityFeedItem', ActivityFeedItemControl, 'RADPresentation.HTMLClient.DefaultViewExtensions');